import React from "react";

import useTranslation from "next-translate/useTranslation";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import Carousel from "shared/components/organisms/Carousel";

import { Container } from "./styles";

const Bundles = ({ course }) => {
  const { t } = useTranslation();
  const bundles = course?.product_bundles;

  const responsivenessSettings = {
    768: { items: 1 },
    1024: { items: 2 },
    1366: { items: 3 },
  };

  const onlyPublishedBundles = bundles?.data.filter(
    (bundle) => bundle.status === "published",
  );

  return (
    <>
      {onlyPublishedBundles?.length > 0 && (
        <Container className="course-custom-card">
          <h1>{t("common:seeThePackagesThatContainTheCourse")}</h1>

          <section className="bundles">
            <div className="slider_container">
              <ComponentErrorBoundary>
                <Carousel
                  zIndex={null}
                  context="bundle"
                  items={onlyPublishedBundles}
                  customResponsivenessSettings={responsivenessSettings}
                />
              </ComponentErrorBoundary>
            </div>
          </section>
        </Container>
      )}
    </>
  );
};

export default Bundles;
